import cn from 'clsx'
import { useTheme } from '~/app/(pages)/(components)/theme'
import { themes } from '~/styles/config'
import s from './theme-button.module.css'

export function ThemeButton({ theme, className, square = false }) {
  const { setTheme } = useTheme()
  const { primary, secondary } = themes[theme]

  return (
    <button
      className={cn(s.button, className, square && s.square)}
      type="button"
      onClick={() => setTheme(theme)}
      style={{ '--primary-color': primary, '--secondary-color': secondary }}
    />
  )
}
